<template>
    <SeatingPlan
        :numberOfSeats="49"
        :doublePlaceholderBefore="[23, 25]"
        :reorderSeats="[45, 46, 49, 47, 48]"
    />
</template>

<script lang="ts" setup>
import SeatingPlan from './SeatingPlan.vue';
</script>
